export const setupDowngradeName = (name: string) => {
  const head = name.slice(0, 1).toLocaleLowerCase();
  const tail = name.slice(1, name.length);
  return `${head}${tail}`;
};
